// Function converts time like "14:30:00" to "2:30 PM"
const convert24to12 = (time) => {
  const [hours, minutes] = time.split(':');
  const period = +hours < 12 ? 'AM' : 'PM';
  const adjustedHours = +hours % 12 || 12;
  return +minutes === 0 ? `${adjustedHours} ${period}` : `${adjustedHours}:${minutes} ${period}`;
};

export default convert24to12;
